import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { SimplePageLayout } from 'components/layouts/SimplePageLayout';
import { PageLayout } from '../../../components/PageLayout';
import { SetPasswordForm } from './SetPasswordForm';

export const Content = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('setPassword.title')}</title>
      </Helmet>
      <SimplePageLayout>
        <SetPasswordForm />
      </SimplePageLayout>
    </>
  );
};

export const SetPassword = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <PageLayout
      data-cname="SetPasswordPage"
      headerBarProps={{ action: '/', title: t('setPassword.title') }}
    >
      <Content />
    </PageLayout>
  );
};
